// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface BookmarkAlt1IconSignature {
  Element: SVGSVGElement;
}

export const BookmarkAlt1Icon: TOC<BookmarkAlt1IconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 2H13H11H6C5.447 2 5 2.447 5 3V21C5 21.404 5.244 21.77 5.617 21.924C5.991 22.078 6.421 21.992 6.707 21.707L12 16.414L17.293 21.707C17.484 21.898 17.74 22 18 22C18.129 22 18.259 21.975 18.383 21.924C18.756 21.77 19 21.404 19 21V3C19 2.447 18.553 2 18 2ZM7 4H11V14.586L7 18.586V4ZM13 14.586L17 18.586V4H13V14.586Z"/>
</svg>
</template>;